import { createContext } from 'react'
import RootStore from './store/RootStore'

export const store = new RootStore()
export const RootContext = createContext(store);
